import { computed, ref } from "vue";
import {
  DEFAULT_LOCALE,
  LOCALES,
  catalogs,
  t as translate,
  type Locale,
  type MessageKey,
} from "@desfecha/i18n";

const STORAGE = "donetalk-locale";

function detect(): Locale {
  try {
    const saved = localStorage.getItem(STORAGE);
    if (saved && (LOCALES as readonly string[]).includes(saved))
      return saved as Locale;
  } catch {
    /* storage unavailable */
  }
  const nav = navigator.language.toLowerCase();
  if (nav.startsWith("pt")) return "pt-BR";
  if (nav.startsWith("es")) return "es";
  if (nav.startsWith("en")) return "en";
  return DEFAULT_LOCALE;
}

export const locale = ref<Locale>(detect());

export function setLocale(next: Locale): void {
  locale.value = next;
  try {
    localStorage.setItem(STORAGE, next);
  } catch {
    /* ignore */
  }
  document.documentElement.lang = next;
}

export function t(
  key: MessageKey,
  vars: Record<string, string | number> = {},
): string {
  return translate(locale.value, key, vars);
}

/** Customer-owned labels stored as { "pt-BR": ..., es: ..., en: ... }. */
export function localized(
  label: Record<string, string> | string | null | undefined,
): string {
  if (!label) return "";
  if (typeof label === "string") return label;
  return (
    label[locale.value] ??
    label[DEFAULT_LOCALE] ??
    Object.values(label)[0] ??
    ""
  );
}

export const localeOptions = computed(() =>
  LOCALES.map((l) => ({ id: l, label: catalogs[l]["locale.name"] })),
);
export type { MessageKey };
